// @flow

import React from 'react';
import Translate from 'client/components/translate';
import ROUTE from 'client/constants/routes';
import { ExtoleReferralSimpleButtonCard } from 'client/components/extole/extoleReferralSimpleButtonCard';
import { ExtoleCreateZoneCard } from 'client/components/extole/extoleCreateZoneCard';
import OsanoCookiePreferencesButton from 'client/components/osano/osanoCookiePreferencesButton';

import '../../styles/footer.scss';

type Props = {
  showCoveredCaliforniaDisclaimer: boolean,
};

const FullFooter = ({ showCoveredCaliforniaDisclaimer = false }: Props) => (
  <footer className="full-footer">
    <div className="row">
      <div className="column large-3 medium-3">
        <p className="full-footer-stride-info">
          <strong>
            <Translate path="common.footer.company" />
          </strong>
          <br />
          <Translate path="common.footer.location" />
          <br />
          <br />
          <a
            href="https://www.facebook.com/stridehealth"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="facebook"
            className="icon">
            <span className="icon-facebook-circled" />
          </a>

          <a
            href="https://twitter.com/stridehealth"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="twitter"
            className="icon">
            <span className="icon-twitter-circled" />
          </a>
          <a
            href="https://instagram.com/stridehealth"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="instagram"
            className="icon">
            <span className="icon-instagram-circled" />
          </a>
        </p>
        <br />
        <ExtoleReferralSimpleButtonCard location="footer" />
      </div>
      <div className="column large-3 medium-3 small-6">
        <ul className="full-footer-ul">
          <li>
            <a className="full-footer-a" href={ROUTE.HEALTH_PROFILE_LOCATION_PATH}>
              <Translate path="common.footer.shop" />
            </a>
          </li>
          <li>
            <a className="full-footer-a" href="/dental">
              <Translate path="common.footer.dental" />
            </a>
          </li>
          <li>
            <a className="full-footer-a" href="/vision">
              <Translate path="common.footer.vision" />
            </a>
          </li>
          <li>
            <a className="full-footer-a" href="/life">
              <Translate path="common.footer.life" />
            </a>
          </li>
          <li>
            <a className="full-footer-a" href="/tax">
              <Translate path="common.footer.tax" />
            </a>
          </li>
          <li className="show-for-small-only-footer">
            <a className="full-footer-a" href="/health-insurance/guide">
              <Translate path="common.footer.insuranceGuide" />
            </a>
          </li>
          <li className="show-for-small-only-footer">
            <a className="full-footer-a" href="/tax/deductions/jobs">
              <Translate path="common.footer.taxDeductions" />
            </a>
          </li>
          <li className="show-for-small-only-footer">
            <a
              className="full-footer-a"
              href="http://support.stridehealth.com/hc/en-us"
              target="_blank"
              rel="noopener noreferrer">
              FAQ
            </a>
          </li>
        </ul>
      </div>
      <div className="column large-3 medium-3 small-6">
        <ul className="full-footer-ul">
          <li>
            <a className="full-footer-a" href="/about">
              <Translate path="common.footer.about" />
            </a>
          </li>
          <li>
            <a className="full-footer-a" href="https://www.stridebenefits.com/partner">
              <Translate path="common.footer.partner" />
            </a>
          </li>
          <li>
            <a className="full-footer-a" href="/blog">
              <Translate path="common.footer.blog" />
            </a>
          </li>
          <li>
            <a className="full-footer-a" href="/careers">
              <Translate path="common.footer.jobs" />
            </a>
          </li>
          <li className="hide-for-small-only-footer">
            <a className="full-footer-a" href="/health-insurance/guide">
              <Translate path="common.footer.insuranceGuide" />
            </a>
          </li>
          <li className="hide-for-small-only-footer">
            <a className="full-footer-a" href="/tax/deductions/jobs">
              <Translate path="common.footer.taxDeductions" />
            </a>
          </li>
          <li className="show-for-small-only-footer">
            <a className="full-footer-a" href="/legal/privacy-policy">
              <Translate path="common.footer.privacy" />
            </a>
          </li>
          <li className="show-for-small-only-footer">
            <a className="full-footer-a" href="/legal/terms-of-use">
              <Translate path="common.footer.terms" />
            </a>
          </li>
          <li className="show-for-small-only-footer">
            <OsanoCookiePreferencesButton />
          </li>
          <li className="show-for-small-only-footer">
            <a
              className="full-footer-a"
              href="/legal/privacy-policy#notices-for-california-residents">
              <Translate path="common.footer.californiaPrivacy" />
            </a>
          </li>
          <li className="show-for-small-only-footer">
            <a className="full-footer-a" href="/resource/language-support/#espanol">
              <Translate path="common.footer.espanol" />
            </a>
          </li>
          <li className="show-for-small-only-footer">
            <a className="full-footer-a" href="/resource/language-support">
              <Translate path="common.footer.otherLanguages" />
            </a>
          </li>
        </ul>
      </div>
      <div className="column large-3 medium-3 hide-for-small-only-footer">
        <ul className="full-footer-ul">
          <li>
            <a
              className="full-footer-a"
              href="http://support.stridehealth.com/hc/en-us"
              target="_blank"
              rel="noopener noreferrer">
              FAQ
            </a>
          </li>
          <li>
            <a className="full-footer-a" href="/legal/privacy-policy">
              <Translate path="common.footer.privacy" />
            </a>
          </li>
          <li>
            <a className="full-footer-a" href="/legal/terms-of-use">
              <Translate path="common.footer.terms" />
            </a>
          </li>
          <li>
            <OsanoCookiePreferencesButton />
          </li>
          <li>
            <a
              className="full-footer-a"
              href="/legal/privacy-policy#notices-for-california-residents">
              <Translate path="common.footer.californiaPrivacy" />
            </a>
          </li>
          <li>
            <a className="full-footer-a" href="/resource/language-support/#espanol">
              <Translate path="common.footer.espanol" />
            </a>
          </li>
          <li>
            <a className="full-footer-a" href="/resource/language-support">
              <Translate path="common.footer.otherLanguages" />
            </a>
          </li>
        </ul>
      </div>
    </div>
    <div className="row">
      <div className="column">
        <div className="full-footer-text">
          <p className="off-white margin">
            <Translate path="common.footer.legalText" />
          </p>
          {showCoveredCaliforniaDisclaimer && (
            <p className="off-white margin">
              <Translate path="common.footer.coveredCalifornia" />
            </p>
          )}
        </div>
      </div>
    </div>
    <div className="row copyright column">
      <div className="full-footer-stride-info">
        <p className="copyright">
          <Translate
            path="common.footer.npn"
            using={{
              year: new Date().getFullYear(),
            }} />
        </p>
      </div>
    </div>
    <ExtoleCreateZoneCard zone_name="overlay" />
  </footer>
);

export default FullFooter;
